import {
	Slider, Button, DialogActions,
	Dialog, DialogTitle, DialogContent, Typography, Tooltip
} from '@material-ui/core';
import React from 'react';
import AvatarEditor from 'react-avatar-editor';
import { CirclePicker } from 'react-color';

const ImageUpload = ({ image, onFinish, id, vehicle, defaultImage }) => {
	const hiddenFileInput = React.useRef(null);
	const [open, setOpen] = React.useState(false);

	const [raw, setRaw] = React.useState(null);
	const [raw2, setRaw2] = React.useState(null);
	let editorRef = React.createRef();

	const [scale, setScale] = React.useState(1);
	const [width, setWidth] = React.useState(128);
	const [height, setHeight] = React.useState(128);
	const [border, setBorder] = React.useState(20);
	const [borderRadius, setBorderRadius] = React.useState(50);
	const [borderColor, setBorderColor] = React.useState("#3f51b5");

	React.useEffect(() => {
		handlePreview();
	}, [borderColor, scale])// eslint-disable-line


	const handleClick = () => {
		hiddenFileInput.current.click();
	};
	const handleChange = event => {
		setRaw(event.target.files[0])
		// console.log(event.target.files[0])
		setOpen(true);
	};

	const handlePreview = () => {
		if (!editorRef.getImageScaledToCanvas) {
			return;
		}
		let img = editorRef.getImageScaledToCanvas().toDataURL();
		let imgdiv = new Image();
		let canvas = document.getElementById("canvas");
		let ctx = canvas.getContext("2d");
		imgdiv.src = img;
		imgdiv.onload = () => {
			let cw, ch;
			cw = canvas.width = imgdiv.width;
			ch = canvas.height = imgdiv.height;

			ctx.beginPath();
			ctx.arc(cw / 2, ch / 2, ch / 2, 0, Math.PI * 2);
			ctx.fill();
			ctx.globalCompositeOperation = 'source-in';
			ctx.drawImage(imgdiv, 0, 0);
			ctx.closePath();

			ctx.beginPath();
			ctx.globalCompositeOperation = "source-atop";
			ctx.lineWidth = 10;
			ctx.arc(cw / 2, ch / 2, ch / 2, 0, Math.PI * 2);
			ctx.strokeStyle = borderColor;
			ctx.stroke();
			ctx.closePath();

			setRaw2(canvas.toDataURL());
		}
	}

	const handleClose = () => {
		setOpen(false);
		hiddenFileInput.current.value = null;
	}

	const setRef = (ref) => {
		if (ref) {
			editorRef = ref;
		}
	}

	const handleColorChange = (color) => {
		setBorderColor(color.hex);
	}

	const handleFinish = () => {
		onFinish({
			image: raw2,
			_id: id
		});
		handleClose();
	}

	return (
		<>
			<Dialog onClose={handleClose} open={open} maxWidth='lg'>
				<DialogTitle>Edit Image</DialogTitle>
				<DialogContent>
					<canvas id="canvas" width='300' height='300' style={{ display: 'none' }} />
					{/* <img id='rawimage' src={raw} /> */}
					{/* <Croppie url={raw} /> */}
					<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
						<div>
							<Typography>Editor(Click to drag):</Typography>
							<AvatarEditor
								ref={setRef}
								image={raw}
								width={width}
								height={height}
								border={border}
								scale={scale}
								backgroundColor={'#ffffff'}
								borderRadius={width / (100 / borderRadius)}
								onPositionChange={handlePreview}
								onLoadSuccess={handlePreview}
							/>
						</div>
						<div style={{ marginLeft: '10px' }}>
							<Typography>Preview:</Typography>
							<img id='rawimage2' src={raw2} />
						</div>
					</div>
					<Typography>Zoom:</Typography>
					<Slider
						size="small"
						min={1}
						defaultValue={1}
						step={0.01}
						max={3}
						aria-label="Small"
						valueLabelDisplay="off"
						onChange={(e, newval) => setScale(newval)}
					/>
					<Typography>Border Colours:</Typography>
					<CirclePicker
						onChange={handleColorChange}
						colors={["#3f51b5", "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]}
					/>
					<DialogActions style={{ justifyContent: 'center' }}>
						<Button onClick={handleFinish} color='primary' variant='outlined'>
							Save
						</Button>
					</DialogActions>
				</DialogContent>
			</Dialog>
			<img
				title="Click to upload an image"
				style={{ cursor: 'pointer' }}
				onClick={handleClick}
				src={image || defaultImage}
				width='64px'
				height='64px'
			/>
			<input type="file" accept="image/*"
				ref={hiddenFileInput}
				onChange={handleChange}
				style={{ display: 'none' }}
			/>
		</>
	);
};
export default ImageUpload;